import React from "react";
import ScoreCircle from "./ScoreCircle";
import KeywordBadges from "./KeywordBadges";

export default function AnalysisReport({
  analysisData = {},
  resumeName = "Resume",
}) {
  const a = analysisData;
  return (
    <div id="ats-report" className="p-6 text-sm text-gray-900 bg-white">
      <h1 className="text-2xl font-bold">{resumeName} - ATS Analysis</h1>
      <p className="text-xs text-gray-500">
        Generated on {new Date().toLocaleString()}
      </p>

      <div className="mt-4 flex items-center gap-6">
        <ScoreCircle score={a.atsScore || 0} size={120} />
        <div>
          <p className="text-sm text-gray-600">
            Readability Score: {a.readabilityScore || 0}
          </p>
        </div>
      </div>

      <div className="mt-4">
        <h2 className="font-semibold">Keywords</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div>
            <p className="text-xs font-medium text-gray-600">Found</p>
            <KeywordBadges keywords={a.keywords?.found || []} type="found" />
          </div>
          <div>
            <p className="text-xs font-medium text-gray-600">Missing</p>
            <KeywordBadges
              keywords={a.keywords?.missing || []}
              type="missing"
            />
          </div>
        </div>
        <p className="text-xs text-gray-500 mt-1">
          Keyword density:{" "}
          {typeof a.keywords?.density === "object"
            ? a.keywords?.density?.overall || 0
            : a.keywords?.density || 0}
        </p>
      </div>

      <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-3">
        <SectionList title="Strengths" items={a.strengths || []} />
        <SectionList title="Weaknesses" items={a.weaknesses || []} />
        <SectionList title="Format Issues" items={a.formatIssues || []} />
      </div>

      <div className="mt-4">
        <h2 className="font-semibold">Suggestions</h2>
        <ol className="list-decimal pl-5 space-y-1">
          {Array.isArray(a.suggestions) ? (
            (a.suggestions || []).map((s, i) => (
              <li key={i}>{typeof s === "string" ? s : s?.title || ""}</li>
            ))
          ) : (
            <li className="text-gray-500">No suggestions available</li>
          )}
        </ol>
      </div>

      <p className="mt-6 text-xs text-gray-500">© Resumly</p>
    </div>
  );
}

function SectionList({ title, items }) {
  return (
    <div>
      <h3 className="font-semibold">{title}</h3>
      <ul className="list-disc ml-5 text-sm mt-1">
        {Array.isArray(items) ? (
          (items || []).map((t, i) => (
            <li key={i}>{typeof t === "string" ? t : t?.title || ""}</li>
          ))
        ) : (
          <li className="text-gray-500">No data available</li>
        )}
      </ul>
    </div>
  );
}
